import { createRouter } from "@tanstack/react-router";
import { rootRoute } from "./root-route.js";

import { indexRoute } from "../features/marketing/LandingScreen.js";
import { loginRoute } from "../features/auth/LoginScreen.js";
import { changePasswordRoute } from "../features/auth/ChangePasswordScreen.js";
import { invitationRoute } from "../features/auth/InvitationScreen.js";
import { forgotPasswordRoute } from "../features/auth/ForgotPasswordScreen.js";
import { resetPasswordRoute } from "../features/auth/ResetPasswordScreen.js";
import { accountRoute } from "../features/auth/AccountScreen.js";
import { appRoute } from "../features/weddings/WeddingsScreen.js";
import { appWeddingRoute } from "../features/weddings/WeddingScreen.js";
import { appEventRoute } from "../features/events/EventScreen.js";
import { adminRoute } from "../features/leads/LeadsScreen.js";
import { adminClientsRoute } from "../features/clients/ClientsScreen.js";
import { adminSettingsRoute } from "../features/settings/SettingsScreen.js";
import { guestRoute } from "../features/guest/GuestScreen.js";
import { guestGalleryRoute } from "../features/guest/GuestGalleryScreen.js";
import { showRoute } from "../features/wall/WallScreen.js";

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  changePasswordRoute,
  invitationRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  accountRoute,
  appRoute,
  appWeddingRoute,
  appEventRoute,
  adminRoute,
  adminClientsRoute,
  adminSettingsRoute,
  guestRoute,
  guestGalleryRoute,
  showRoute,
]);

export const router = createRouter({ routeTree, defaultPreload: "intent" });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
